import { render, staticRenderFns } from "./settingNew.vue?vue&type=template&id=61ef24e4&scoped=true"
import script from "./settingNew.vue?vue&type=script&lang=js"
export * from "./settingNew.vue?vue&type=script&lang=js"
import style0 from "./settingNew.vue?vue&type=style&index=0&id=61ef24e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ef24e4",
  null
  
)

export default component.exports